<template>
  <div class="approved-list-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>信息管理</el-breadcrumb-item>
        <el-breadcrumb-item>审核未通过</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-divider></el-divider>
    <!-- 表格容器 -->
    <div class="as-container">
      <avue-crud ref="crud"
                 style="width: 95%;
                 margin: 0 auto"
                 :data="tableData"
                 :option="option"
                 :page.sync="page"
                 :table-loading="tableLoading"
                 :search.sync="search"
                 @on-load="onLoad"
                 @search-change="searchChange"
                 @search-reset="resetChange">
        <template slot="menu" slot-scope="{row}">
          <el-button type="info" size="small" @click="viewInfo(row)">详情</el-button>
          <el-button size="small" type="primary" @click="rowEdit(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="rowDelete(row.id)">删除</el-button>
        </template>
        <template slot="status" slot-scope="{row}">
          <el-tag size="small" type="warning" v-if="row.status === '0'">待审核</el-tag>
          <el-tag size="small" type="danger" v-if="row.status === '2'">审核未通过</el-tag>
          <el-tag size="small" type="success" v-if="row.status === '1'">审核通过</el-tag>
        </template>
        <template slot="rank" slot-scope="{row}">
          <el-tag size="small" type="warning" v-if="row.rank === '0'">全部可见</el-tag>
          <el-tag size="small" type="danger" v-if="row.rank === '1'">栏目内可见</el-tag>
          <el-tag size="small" type="success" v-if="row.rank === '2'">特殊权限可见</el-tag>
        </template>
      </avue-crud>
    </div>

    <!-- 加载状态 -->
    <div v-if="tableLoading" class="loading-empty">
      <el-skeleton :rows="10" active></el-skeleton>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog title="详情"
               v-dialogDrag
               :visible.sync="viewVisible"
               class="avue-dialog"
               :width="isMobile ? '95%' : '80%'">
      <h3 style="margin-bottom: 20px">基本信息</h3>
      <el-descriptions border :column="2" size="small">
        <!-- ID -->
        <el-descriptions-item label="ID">{{ data.id || '无' }}</el-descriptions-item>
        <!-- 问题编号 -->
        <el-descriptions-item label="问题编号">{{ data.questionNo || '无' }}</el-descriptions-item>
        <!-- 标题 -->
        <el-descriptions-item label="标题">{{ data.title || '无' }}</el-descriptions-item>
        <!-- 录入人员工号 -->
        <el-descriptions-item label="录入人员工号">{{ data.workNo || '无' }}</el-descriptions-item>
        <!-- 关联系统 -->
        <el-descriptions-item label="关联系统">{{ getSystemName(data.systemId) || '无' }}</el-descriptions-item>
        <!-- 栏目（新增） -->
        <el-descriptions-item label="栏目">{{ getCategoryPath(data.categoryId) || '无' }}</el-descriptions-item>
        <!-- 创建时间 -->
        <el-descriptions-item label="创建时间">
          {{ data.createTime ? data.createTime : '无' }}
        </el-descriptions-item>
        <!-- 状态 -->
        <el-descriptions-item label="状态">
          <el-tag size="small" type="warning" v-if="data.status === '0'">待审核</el-tag>
          <el-tag size="small" type="danger" v-if="data.status === '2'">审核未通过</el-tag>
          <el-tag size="small" type="success" v-if="data.status === '1'">审核通过</el-tag>
        </el-descriptions-item>
        <!-- 可见范围 -->
        <el-descriptions-item label="状态">
          <el-tag size="small" type="warning" v-if="data.rank === '0'">全部可见</el-tag>
          <el-tag size="small" type="danger" v-if="data.rank === '1'">栏目内可见</el-tag>
          <el-tag size="small" type="success" v-if="data.rank === '2'">特殊权限可见</el-tag>
        </el-descriptions-item>
        <!-- 审核意见 -->
        <el-descriptions-item label="审核意见" v-if="data.questionReview && data.questionReview.reviewComments">
          {{ data.questionReview.reviewComments }}
        </el-descriptions-item>
      </el-descriptions>
      <el-divider/>
      <h3 style="margin-bottom: 20px">问题描述</h3>
      <div v-html="data.description || '无'"></div>
      <el-divider/>
      <h3 style="margin-bottom: 20px">问题解决方式</h3>
      <div v-html="data.resolution || '无'" style="margin-bottom: 50px"></div>
      <div class="avue-dialog__footer">
        <el-button @click="viewVisible = false" type="primary">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 引入编辑抽屉组件 -->
    <info-edit-drawer
        :visible="editDrawerVisible"
        :row-data="currentRow"
        :category-data="categoryData"
        :system-data="systemData"
        @save="handleSave"
        @close="editDrawerVisible = false"
    />

  </div>
</template>

<script>
import InfoEditDrawer from "../components/infoEditDrawer/InfoEditDrawer"; // 导入组件
import {getAllList} from "@/api/associatedSystem/associatedSystem";
import {getLocal} from "@/utils/localstorage";

export default {
  name: "ApprovedListView",
  components:{InfoEditDrawer},
  data() {
    return {
      userInfo:undefined,//登录用户信息
      viewVisible: false,
      isMobile: window.innerWidth <= 768, // 初始化时判断是否为移动端
      tableData: [],
      categoryData: [],//栏目数据
      systemData:[],//关联系统数据
      dictLoaded: false, // 字典数据是否加载完成
      data: {
        questionReview:{}//审核意见数据
      },//详情数据
      page: {
        layout: window.innerWidth <= 768 ? 'prev, next' : 'total, sizes, prev, pager, next, jumper', // 分页组件布局
        total: 0, // 总记录数
        currentPage: 1, // 当前页码
        pageSize: 5, // 每页记录数
        pageSizes: [5, 20, 50, 100] // 可选每页记录数
      },
      option: {
        searchIndex: 4,
        searchIcon: true,
        menuWidth: 220,
        border: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        searchSpan: 6,
        column: [
          {
            label:'ID',
            prop: 'id',
            hide: true
          },
          {
            label: '问题编号',
            prop: 'questionNo',
            hide: true
          },
          {
            label: '标题',
            prop: 'title',
            search: true,
            searchOrder: 4
          },
          {
            label: '录入人员工号',
            prop: 'workNo',//修改表格中的数据名，对应数据库
            hide: true
          },
          {
            label: '关联系统',
            prop: 'systemId',
            align: 'center',
            search: true ,
            searchOrder: 3,
            type: 'select',
            dicData:this.systemData // 绑定关联系统数据源
          },
          {
            label: '栏目',
            prop: 'categoryId',
            align: 'center',
            searchOrder: 2,
            search: true,
            type: 'cascader',
            dicData: this.categoryData //绑定栏目数据
          },
          {
            label: '关键字',
            prop: 'keywords',
            search: true,
            searchOrder: 1,
            hide: true
          },
          {
            label: '录入时间',
            prop: 'createTime',
            hide: true
          },
          {
            label: '问题描述',
            prop: 'description',
            hide: true
          },
          {
            label: '问题解决方式',
            prop: 'resolution',
            hide: true
          },
          {
            label: '状态',
            prop: 'status',
            align: 'center',
            slot: true
          },
          {
            label: '可见范围',
            prop: 'rank',
            align: 'center',
            slot: true
          }
        ],
      },
      search: {
        size: 10,
        current: 1,
        status: '0',
        pageFrom: "approveFailed"
      },
      tableLoading: false, // 表格加载状态
      debounceTimer: null, // 防抖定时器
      requestCount: 0, // 请求计数器

      editDrawerVisible: false, // 抽屉显示状态
      currentRow: null, // 当前编辑行数据
    }
  },
  // 添加计算属性过滤列
  computed: {
    visibleColumns() {
      return this.option.column.filter(item => {
        return item.prop !== 'description' && item.prop !== 'resolution';
      });
    }
  },
  async mounted() {
    await this.initPageData();
    // 监听窗口大小变化，动态更新移动端状态
    // 初始化时判断是否为移动端
    this.isMobile = window.innerWidth <= 768;
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 组件销毁前清理定时器
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 初始化页面数据
    async initPageData() {
      try {
        const userInfo = getLocal("successInfo");//获取localStorage中的successInfo；
        if (!userInfo) {
          this.$message.warning({ message: '登录过期', onClose: () => this.$router.push('/') });
          return;
        }
        this.userInfo = JSON.parse(userInfo);

        // 1. 优先加载字典数据（栏目+关联系统）
        this.tableLoading = true; // 提前开启加载状态
        await Promise.all([
          this.getCategoryList(),  // 栏目数据
          this.getRelationList()   // 关联系统数据
        ]);

        // 2. 字典加载完成后，标记状态并初始化表格数据
        this.dictLoaded = true;
        this.loadData({}, false); // 触发表格数据加载（强制立即执行）
      } catch (error) {
        console.error('初始化失败:', error);
        this.tableLoading = false; // 加载失败关闭状态
      }
    },
    // 处理窗口大小变化
    handleResize() {
      const newIsMobile = window.innerWidth <= 768;
      // 仅当设备类型发生变化时才更新（优化性能）
      if (newIsMobile !== this.isMobile) {
        this.isMobile = newIsMobile;
        // 同步更新分页布局
        this.page.layout = newIsMobile ? 'prev, next' : 'total, sizes, prev, pager, next, jumper';
      }
    },
    // 加载数据（带防抖处理）
    loadData(params = {}, force = false) {
      if (!this.dictLoaded) return; // 字典未就绪，不执行加载
      this.tableLoading = true;
      // 清除已有的防抖定时器
      if (this.debounceTimer) clearTimeout(this.debounceTimer);

      // 创建一个临时参数对象，避免修改原始search对象
      const tempParams = { ...this.search, ...params };

      // 非强制请求时使用防抖（延迟300ms执行）
      if (!force) {
        this.debounceTimer = setTimeout(() => {
          this._executeLoadData(tempParams);
        }, 300);
        return;
      }


      this._executeLoadData(tempParams);
    },

    // 执行数据加载的具体逻辑
    async _executeLoadData(params) {
      const requestId = ++this.requestCount;
      try {
        // 处理页码、页大小和搜索条件
        const currentPage = Math.max(1, params.currentPage || this.page.currentPage);
        const pageSize = Math.max(1, params.pageSize || this.page.pageSize);

        // 关键逻辑：如果当前请求ID与计数器不一致，说明响应已过时，直接返回
        if (requestId !== this.requestCount) return;

        // 构造请求参数
        let loadParams = {
          current: currentPage,
          size: pageSize
        };

        // 合并搜索参数
        Object.keys(params).forEach(key => {
          if (key !== 'current' && key !== 'size' && params[key] !== '') {
            loadParams[key] = params[key];
          }
        });

        // 特殊处理categoryId：提取末级ID并存入categoryId，传给后端
        if (params.categoryId && Array.isArray(params.categoryId) && params.categoryId.length > 0) {
          loadParams.categoryId = params.categoryId[params.categoryId.length - 1];
        }

        // 获取列表数据
        const res = await this.$api.questionApi.getList(loadParams);
        if (res.code === 200) {
          const result = res.data;
          this.page = {
            ...this.page,
            currentPage,
            pageSize,
            total: result.total
          };
          this.tableData = result.records || [];
        } else {
          this.$message.error('加载数据失败：' + (res.message || '请稍后再试'));
          console.error('数据加载错误', res);
        }

        // 表格数据加载完成后，等待DOM更新再关闭加载状态
        this.$nextTick(() => {
          if (requestId === this.requestCount) {
            this.tableLoading = false; // 此时字典已就绪，表格数据也加载完成
          }
        });
      } catch (error) {
        this.$message.error('加载数据失败：' + (error.message || '请稍后再试'));
        console.error('数据加载异常', error);
        this.tableLoading = false;
      }
    },
    // 根据systemId获取关联系统名称
    getSystemName(systemId) {
      if (!systemId || !this.systemData.length) return '';
      const system = this.systemData.find(item => item.value == systemId);
      return system ? system.label : '未知系统';
    },
    /**
     * 根据栏目ID获取完整的栏目路径（如："父栏目 > 子栏目 > 孙栏目"）
     * @param {String/Number} targetId - 目标栏目ID
     * @param {Array} treeData - 树形栏目数据（默认使用categoryData）
     * @returns {String} 完整栏目路径
     */
    getCategoryPath(targetId, treeData = this.categoryData) {
      if (!targetId || !treeData || !treeData.length) return '';

      let path = [];
      // 递归查找目标节点并收集路径
      const findNode = (nodes) => {
        for (const node of nodes) {
          if (node.value === targetId) {
            // 找到目标节点，添加当前节点名称
            path.push(node.label);
            return true; // 终止递归
          }
          if (node.children && node.children.length) {
            // 递归查找子节点
            const found = findNode(node.children);
            if (found) {
              // 找到子节点后，将当前节点名称添加到路径头部（因为是父级）
              path.unshift(node.label);
              return true;
            }
          }
        }
        return false;
      };

      // 执行查找
      findNode(treeData);

      // 拼接路径（如："技术 > 前端 > Vue"）
      return path.length ? path.join(' > ') : '未知栏目';
    },
    // 获取用户栏目范围列表（包含错误处理）
    async getCategoryList() {
      try {
        const workNo = this.userInfo.workNo

        const res = await this.$api.categoryApi.getDataByWorkNo(workNo);
        if (res && res.data) {
          const treeData = this.transformToTree(res.data);
          this.categoryData = treeData;
          // 手动更新表格列的dicData（关键）
          const categoryColumn = this.option.column.find(col => col.prop === 'categoryId');
          if (categoryColumn) {
            categoryColumn.dicData = treeData; // 同步更新列配置的字典数据
          }
        } else {
          console.warn('栏目数据为空');
          this.categoryData = [];
        }
      } catch (err) {
        console.error('获取栏目列表失败', err);
        this.$message.error('获取栏目列表失败，请重试');
        throw err; // 确保Promise.all能捕获错误
      }
    },

    /**
     * 转换嵌套数据为树形结构
     * @param {Array} data 原始数据数组
     * @returns {Array} 转换后的树形结构数组
     */
    transformToTree(data) {
      return data.map(item => {
        // 构建基础节点
        const node = {
          value: item.id.toString(), // 转换为字符串
          label: item.title
        };

        // 递归处理子节点
        if (item.children && item.children.length > 0) {
          node.children = this.transformToTree(item.children);
        }
        return node;
      });
    },

    // 获取关联系统列表（包含错误处理）
    async getRelationList() {
      try {
        const res = await getAllList();
        if (res && res.data) {
          const resultData = res.data.map(item => ({
            value: item.id,
            label: item.systemName
          }));

          this.systemData = resultData;

          // 手动更新表格列的dicData（关键）
          const systemColumn = this.option.column.find(col => col.prop === 'systemId');
          if (systemColumn) {
            systemColumn.dicData = resultData; // 同步更新列配置的字典数据
          }

        } else {
          console.warn('关联系统数据为空');
          this.systemData = [];
        }
      } catch (err) {
        console.error('获取关联系统列表失败', err);
        this.$message.error('获取关联系统列表失败，请重试');
        throw err; // 确保Promise.all能捕获错误
      }
    },

    // 查看详情
    viewInfo(row) {
      this.viewVisible = true;
      this.data = { ...row };
    },

    // 搜索条件变化处理
    searchChange(params, done) {

      // 合并搜索参数，并强制重置页码为1
      Object.assign(this.search, params, { current: 1 });
      // 更新页面状态中的页码
      this.page.currentPage = 1;
      this.loadData(this.search, true);
      done(params);
    },

    // 重置搜索条件
    resetChange() {
      // 重置搜索条件
      this.search = {
        size: this.page.pageSize,
        current: 1,
        status: this.search.status,
        pageFrom: "approveFailed"
      };
      // 重置时不是搜索操作，需要清空栏目参数
      this.search.categoryId = undefined;
      this.loadData(this.search, true);
    },

    // 编辑按钮点击
    rowEdit(row) {
      this.currentRow = row;
      this.editDrawerVisible = true;
    },

    // 处理保存
    async handleSave(formData) {
      try {
        formData.pageFrom = "approveFailed";
        const res = await this.$api.questionApi.updateData(formData);
        if (res.code === 200) {
          this.$message.success("修改成功");
          this.editDrawerVisible = false;
          this.loadData({}, true); // 刷新表格
        } else {
          this.$message.error(res.message || "修改失败");
        }
      } catch (err) {
        console.error("修改失败", err);
        this.$message.error("修改失败，请重试");
      }
    },
    rowDelete(id) {
      this.$confirm('确定删除这条记录吗？', '确认信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 执行删除操作
        return this.$api.questionApi.deleteData(id);
      }).then((res) => {
        // 处理 API 响应
        if (res.code === 200) {
          this.$message.success('删除成功！');
          this.loadData({}, true);
        } else {
          throw new Error(res.message || '删除失败');
        }
      }).catch((err) => {
        // 区分取消操作和API错误
        if (err === 'cancel') {
          // 用户点击取消按钮
          // console.log('用户取消了删除操作');
        } else if (err === 'close') {
          // 用户点击右上角关闭按钮
          // console.log('用户关闭了确认对话框');
        } else {
          // 处理API错误或其他异常
          this.$message.error('删除失败：' + (err.message || '未知错误'));
        }
      });
    },

    // 分页变化处理
    onLoad(page) {
      if (!this.dictLoaded) return; // 字典未就绪，不加载表格数据
      this.page = page;
      this.loadData({
        currentPage: page.currentPage,
        pageSize: page.pageSize
      });
    },

    // 显示字典值
    showDictValue(val, dicArr) {
      if (val != "" && val !== undefined) {
        const item = dicArr.find(item => item.value == val);
        return item ? item.content : val;
      }
      return '';
    }
  }
}
</script>

<style scoped>
/* 页面整体样式 */
.approved-list-container {
  padding: 24px;
  background-color: #f8fafc;
}
/* 面包屑样式 */
.breadcrumb {
  margin-bottom: 16px;
}
.el-breadcrumb {
  font-size: 14px;
  color: #606266;
}
.el-divider {
  margin: 0 0 16px;
}
/* 表格容器样式 */
.as-container {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  padding: 16px;
  margin-bottom: 16px;
}
/* 表格行悬停效果 */
.el-table__row:hover {
  background-color: #f5f7fa !important;
}
/* 按钮美化 */
.el-button {
  border-radius: 4px;
  transition: all 0.3s;
  padding: 0 12px;
  height: 32px;
  font-size: 13px;
}
.el-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
}
.el-button--primary {
  background-color: #409EFF;
  border-color: #409EFF;
}
.el-button--primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}
.el-button--danger {
  background-color: #f56c6c;
  border-color: #f56c6c;
}
.el-button--danger:hover {
  background-color: #f78989;
  border-color: #f78989;
}
.el-button--info {
  background-color: #909399;
  border-color: #909399;
}
.el-button--info:hover {
  background-color: #a6a9ad;
  border-color: #a6a9ad;
}
/* 表单样式 */
.form-container {
  padding: 16px;
}
.el-form-item {
  margin-bottom: 18px;
}
.el-input, .el-select {
  border-radius: 4px;
}
/* 空数据样式 */
.empty-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #909399;
  padding: 20px;
}
.empty-icon {
  font-size: 64px;
  color: #dcdfe6;
  margin-bottom: 16px;
}
.empty-text {
  margin-bottom: 16px;
  font-size: 14px;
}
/* 加载状态样式 */
.loading-empty {
  padding: 40px 0;
  display: flex;
  justify-content: center;
}

/* 详情弹窗中的图片自适应 */
::v-deep .avue-dialog .el-dialog__body img {
  max-width: 100% !important; /* 图片最大宽度不超过容器 */
  height: auto !important; /* 保持图片原始比例 */
  display: block; /* 避免图片底部出现多余空白 */
  margin: 10px auto; /* 图片居中显示 */
}

/* 解决移动端弹窗内容溢出问题 */
::v-deep .avue-dialog .el-dialog__body {
  overflow-x: hidden; /* 禁止横向滚动 */
  padding: 15px; /* 减小移动端内边距，增加可用空间 */
}

/* 移动端弹窗宽度调整 */
@media screen and (max-width: 768px) {
  ::v-deep .avue-dialog .el-dialog {
    width: 95% !important; /* 移动端弹窗宽度占屏幕95% */
    margin: 10px auto !important; /* 避免顶部留白过多 */
  }

  /* 移动端描述文本换行优化 */
  ::v-deep .avue-dialog .el-descriptions__content {
    word-break: break-word; /* 长文本自动换行 */
  }
}

/* 在 style 标签中添加移动端分页样式 */
@media screen and (max-width: 768px) {
  /* 调整分页按钮大小和间距 */
  ::v-deep .el-pagination {
    padding: 10px 0;
  }
  ::v-deep .el-pagination button {
    width: 36px;
    height: 36px;
    padding: 0;
    margin: 0 2px;
  }
  /* 确保按钮文字居中 */
  ::v-deep .el-pagination button .el-icon {
    vertical-align: middle;
  }
}
</style>